module.exports = __webpack_public_path__ + "media/images/pdf-38273f4f.svg";